import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Image from 'components/image/image'
import Checkout from 'components/checkout/checkout'
import Panel from 'components/panel/panel'
import Meta from 'components/meta/meta'
import Heading from 'components/heading/heading'
import Icon from 'components/icon/icon'
import Btn from 'components/btn/btn'
import Select from 'components/input/select/select'
import Infoblock from 'components/infoblock/infoblock'
import VatInfo from 'components/vat-info/vat-info'
// import ShipTime from 'components/ship-time/ship-time'
import styles from 'styles/page/pirkimas-krepselis.module.scss'
import useAppState from 'utils/state'
import { get } from 'utils/api'
import { getCartAccounts, getRoute, getQuantityOptions, getCartId } from 'utils/helpers'

export default function Page() {
    const [accInfo, setAccInfo] = useState()
    const router = useRouter()
    const {
        cart,
        loading,
        removeFromCart,
        changeCartQuantity,
        selectCheckoutAccount,
        user,
        coupon,
        couponCheck
    } = useAppState()

    const handleAccountCheckout = slug => {
        selectCheckoutAccount(slug)
        router.push(getRoute(user ? 'checkout-delivery' : 'checkout-info'))
    }

    useEffect(() => {
        if (!loading) {
            const getInfo = async () => {
                const slugs = [...new Set(cart.items.map(item => item.account_slug))]
                if (slugs.length) {
                    const response = await get('accounts-discounts', { slugs: slugs.join(',') })
                    if (response && response.data && response.data.data && response.data.data.accounts) {
                        setAccInfo(response.data.data.accounts)
                    } else {
                        setAccInfo({})
                    }
                } else {
                    setAccInfo({})
                }
            }
            getInfo()
        }
    }, [coupon, loading])

    const cartGroups = getCartAccounts(cart.items, accInfo, couponCheck)

    return (
        <Checkout>
            <Meta title="Krepšelis" description="Apmokėjimui ir užsakymui paruoštų prekių sąrašas." />
            {/*<ShipTime />*/}
            <>
                {cartGroups.length > 1 && (
                    <Infoblock className="mb48">
                        Prekės siunčiamos tiesiogiai iš gamintojų. Taip išvengiama papildomų sąnaudų sandėliavimui ir
                        prekės jus pasiekia grečiau.
                        <br />
                        Todėl krepšeliai bus išskaidyti į skirtingus užsakymus. Kiekvienas užsakymas atliekamas
                        atskirai.
                    </Infoblock>
                )}
                {cartGroups.map(({ name, slug, vat_size, items, total }) => {
                    return (
                        <Panel key={name} className="mb48" desktop>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th colSpan="2">
                                            <Heading tag="h3" size="24">
                                                <Link href={getRoute('shop', { slug })}>
                                                    <a>„{name}“</a>
                                                </Link>{' '}
                                                krepšelis
                                            </Heading>
                                        </th>
                                        <th className={styles.itemPrice}>Kaina</th>
                                        <th className={styles.qty}>Kiekis</th>
                                        <th className={styles.sum}>Suma</th>
                                        <th className={styles.actions}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(product => {
                                        const { image, name, data, max_quantity } = product
                                        const { price_fixed: price, quantity, options } = data

                                        const cartId = getCartId(product)

                                        return (
                                            <tr key={cartId}>
                                                <td className={styles.img}>
                                                    <div className={styles.image}>
                                                        <Image
                                                            src={image}
                                                            alt={name}
                                                            layout="responsive"
                                                            width={72}
                                                            height={72}
                                                        />
                                                    </div>
                                                </td>
                                                <td className={styles.name}>
                                                    <Link href={getRoute('product', product)}>
                                                        <a>{name}</a>
                                                    </Link>
                                                    <div>
                                                        {options && (
                                                            <small>
                                                                {Object.keys(options)
                                                                    .map(k => options[k])
                                                                    .join(', ')}
                                                            </small>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="tabletDesktopHide">Kaina: </span>
                                                    {parseFloat(price).toFixed(2)}€
                                                </td>
                                                <td className={styles.quantity}>
                                                    <Select
                                                        simple
                                                        name="quantity"
                                                        options={getQuantityOptions(max_quantity)}
                                                        value={quantity}
                                                        className={styles.input}
                                                        onChange={e => changeCartQuantity(cartId, e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <span className="tabletDesktopHide">Suma: </span>
                                                    {(quantity * price).toFixed(2)}€
                                                </td>
                                                <td className={styles.remove}>
                                                    <Icon icon="x" onClick={() => removeFromCart(cartId)} />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            <div className={styles.bottom}>
                                <div className={styles.left}>
                                    <VatInfo includes={!!vat_size} />
                                </div>
                                <div className={styles.right}>
                                    <div className={styles.total}>Iš viso: {total ? `${total.toFixed(2)}€` : ''}</div>
                                    <Btn
                                        className={styles.cta}
                                        style="yellow"
                                        onClick={() => handleAccountCheckout(slug)}
                                    >
                                        Pirkti
                                    </Btn>
                                </div>
                            </div>
                        </Panel>
                    )
                })}
            </>
        </Checkout>
    )
}
